import { useState } from 'react';
import { Button } from '@gogame/components';

export const InnerComponent = () => {
  const [data, setData] = useState({ user: { name: 'name' } });
  const handleRenderError = () => {
    setData([]);
  };
  return (
    <>
      <b>Inner Component {data.user.name}</b>
      <Button onClick={handleRenderError}>Generate render Error in Inner component</Button>
    </>
  );
};
